import { inject, Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentDto, GetAllEnvironmentsResponse, GetTenantResponse, TenantDto } from './tenant.interface';

const GET_TENANTS: DocumentNode = gql`
  query GetAllTenantsAsync {
    GetAllTenantsAsync {
      id
      name
      logoUrl
      email
      address
      city
      phone
      fax
      zipCode
      country
      state
      timeZone
    }
  }
`;

const GET_ALL_ENVIRONMENTS: DocumentNode = gql`
  query GetAllEnvironments {
    GetAllEnvironments {
      id
      name
    }
  }
`;

/** Service for retrieving tenant and environment data via GraphQL API. */
@Injectable()
export class TenantService {
  /** Apollo client for GraphQL queries. */
  private readonly apollo: Apollo = inject(Apollo);

  /** Retrieves all tenants from the API. */
  public getTenants(): Observable<Array<TenantDto>> {
    return this.apollo
      .query<GetTenantResponse>({
        query: GET_TENANTS,
        fetchPolicy: 'network-only'
      })
      .pipe(map((result): Array<TenantDto> => result.data?.GetAllTenantsAsync ?? []));
  }

  /** Retrieves all environments from the API. */
  public getEnvironments(): Observable<Array<EnvironmentDto>> {
    return this.apollo
      .query<GetAllEnvironmentsResponse>({
        query: GET_ALL_ENVIRONMENTS,
        fetchPolicy: 'network-only'
      })
      .pipe(map((result): Array<EnvironmentDto> => result.data?.GetAllEnvironments ?? []));
  }
}
